import { render, staticRenderFns } from "./EdutalkBusiness.vue?vue&type=template&id=267315d0&scoped=true"
import script from "./EdutalkBusiness.vue?vue&type=script&lang=js"
export * from "./EdutalkBusiness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267315d0",
  null
  
)

export default component.exports